import { Component, OnInit, ViewChild } from '@angular/core';
import {DatePipe} from '@angular/common';
import {AbstractControl, FormBuilder, FormGroup, FormArray, Validators} from '@angular/forms';
import { MembershipPaymentService } from '../services/membership-payment.service';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import * as dropin from 'braintree-web-drop-in';
import {Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { StripeService, StripeCardComponent } from 'ngx-stripe';
import {
  StripeCardElementOptions,
  StripeElementsOptions,
  loadStripe
} from '@stripe/stripe-js';
import * as moment from 'moment';

export interface Member {
  name: string;
  relation: string;
}

declare var App;
declare var Stripe;

@Component({
  selector: 'app-membership-payment',
  templateUrl: './membership-payment.component.html',
  styleUrls: ['./membership-payment.component.scss']
})

export class MembershipPaymentComponent implements OnInit {
@ViewChild(StripeCardComponent, {static: false}) card: StripeCardComponent;
@ViewChild ('stepper', {static: false}) matStepper: MatStepper;
  cardOptions: StripeCardElementOptions = {
  	hidePostalCode: true,
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '500',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '15px',
        '::placeholder': {
          color: '#CFD7E0'
        }
      },
	  invalid: {
	    color: '#fa755a',
	    iconColor: '#fa755a'
	  }
    }
  };

 
	userDetails = App.user_details;
	plan_details = App.plan_data;
	href_url = App.froent_end_url;
	public telemedicine = App.public_url + 'telemedicine';
	public userMaleIcon = App.public_url + 'telemedicine/assets/images/user_male.svg';
	public userFemaleIcon = App.public_url + 'telemedicine/assets/images/user_female.svg';
	public userMaleColorIcon = App.public_url + 'telemedicine/assets/images/user_male.svg';
	public userFemaleColorIcon = App.public_url + 'telemedicine/assets/images/user_female.svg';
	public greenTickIcon = App.public_url + 'telemedicine/assets/images/tick_green.svg';
	public plusIcon = App.public_url + 'telemedicine/assets/images/Plus.svg';
	public closeIcon = App.public_url + 'telemedicine/assets/images/Close.svg';
	public stripeValidation: string = '';
	public isPay: boolean = false;
	public coupounId = '';
	public addFamily : boolean = false;
	members: Member[] = [
		{
			name: this.userDetails.name,
			relation: 'Primary Member',
		}
	];

	coverage_type = [
		{ id: '1', value: 'FAM' },
		{ id: '2', value: 'FAM2' },
	];
	
	States = [];

	userForm: FormGroup;
	familyForm: FormGroup;
	isEditable = false;
	submitted = false;
	currentStep = 'Member Registration';
	submitStatusMsgSuccess: boolean = false;
	submitStatusMsgFailed: boolean = false;
	isLoading: boolean = false;
	successful_username = '';
	
	authorize_key = '';
	braintreeIsReady: boolean = false;
	dropIninstance: any;

	couponDiscount = '0';
	additional_charges = "2.01";
	total = 0;
	emptyCoupon = false;
	
	showRecurring:boolean = false;
	toogleRecurring: boolean = false;
	showOrganization: boolean = false;
	isCouponApplied: boolean = false;
	form1Submitted: boolean = false;
	form2Submitted: boolean = false;
	formMemberSubmitted: boolean = false;
	organizations_list = [];
	public effectiveMinDate: any;
	public terminationMinDate: any
	public prevPlanAmount: any;
	public phoneMaxLength = 12;
	public phoneMinLength = 12;
	public familyMembers = [];
	public added : boolean = false

	constructor(private _formBuilder: FormBuilder,
				private m_pService: MembershipPaymentService,
				private datePipe: DatePipe,
				private route: Router,
				private stripeService: StripeService) { 
      this.m_pService.updateUserTimeZone({time_zone: new Date().getTimezoneOffset()}).subscribe(response => {
      });
			if(!this.plan_details){
				this.goToPage('telemedicine')
		      // window.location.href= App.froent_end_url + "telemedicine";
			}
				// this.effectiveMinDate = '2020-10-10';
			this.m_pService.getUserPlanStartDate({plan_id: App.plan_data.plan_id, timezone: new Date().getTimezoneOffset()}).subscribe(response => {
				this.effectiveMinDate = this.terminationMinDate = response.result.data.effective_date;
				// this.effectiveMinDate = new Date('2020,10,10');
			})
			this.m_pService.getAllFamilyMembers('').subscribe(response => {
				this.familyMembers = response.result.data
				// console.log('fm',this.familyMembers)
			})
	}


  stripeTest: FormGroup;

	ngOnInit() {
    this.stripeTest = this._formBuilder.group({
      name: ['', [Validators.required]]
    });
		   // this.route.navigate(['http://192.168.1.5/tnc_web/telemedicine']);
		this.userForm = this._formBuilder.group({
			formArray: this._formBuilder.array([
				this._formBuilder.group({
					first_name: ['', Validators.required],
					middle_initial: [''],
					last_name: ['', Validators.required],
					//coverage_type: ['FAM', Validators.required],
					effective_date: [''],
					noOfMonths: [(this.plan_details.month !== '') ? this.plan_details.month : '', Validators.required],
					// noOfMonths: ['2'],
					termination_date: ['', Validators.required],
					//phone: [''],
					cell_phone: ['', [Validators.required, Validators.min(12)]], //, Validators.pattern('^[0-9]{1}-[0-9]{3}-[0-9]{3}-[0-9]{4}$')
					email: [this.userDetails.user_email, Validators.required],
					gender: [''],
					dob: ['', Validators.required],
					//location: [''],
					//employee_number: [{value : App.employee_number, disabled: true}],
					//group_name: [''],
					//group_number: [''],
					address1: ['', Validators.required],
					//address2: [''],
					postal_code: [''],
					city: [''],
					state: [''],
					//country: ['US'],
				}),
				this._formBuilder.group({
					same_as_primary: [''],
					full_name: ['', Validators.required],
					address_line_1: ['', Validators.required],
					//address_line_2: [''],
					postal_code2: ['', Validators.required],
					city2: ['', Validators.required],
					state2: ['', Validators.required],
					//country2: ['US'],
					coupon_code: [''],
					update_page: [''],
					organization: [''],
					recurring_payment: ['']
				})
			])
		});
		this.userForm.get('formArray')['controls'][0].get('first_name').setValue(this.userDetails.first_name);
		this.userForm.get('formArray')['controls'][0].get('last_name').setValue(this.userDetails.last_name);
		// this.userForm.get('formArray')['controls'][0].get('effective_date').setValue(new Date(this.effectiveMinDate));
		this.familyForm = this._formBuilder.group({
					id:[''],
					first_name: [ '', Validators.required],
					middle_initial: [''],
					last_name: ['', Validators.required],
					effective_date: [''],
					noOfMonths: [(this.plan_details.month !== '') ? this.plan_details.month : '', Validators.required],
					termination_date: ['', Validators.required],
					cell_phone: ['', [Validators.required, Validators.min(12)]], //, Validators.pattern('^[0-9]{1}-[0-9]{3}-[0-9]{3}-[0-9]{4}$')
					email: ['', Validators.compose([Validators.required, Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'), Validators.minLength(1)])],
					gender: [''],
					dob: ['', Validators.required],
					address1: ['', Validators.required],
					postal_code: [''],
					city: [''],
					state: [''],
		});
		if(parseInt(App.plan_data.month) > 1) {
		this.userForm.get('formArray')['controls'][0].controls.noOfMonths.disable()
		}
		// this.userForm.get('formArray')['controls'][0].controls.email.disable()			
		this.getStates({country_name: 'US'});
	}

	showOptions(event) {
		this.toogleRecurring = event.checked
	}

	addFamilyMem() {
		this.formMemberSubmitted=false;
		this.form1Submitted=false;
		this.addFamily=true;
		this.added=false;
		this.familyForm.get('id').setValue('')
		this.familyForm.get('first_name').setValue('')
		this.familyForm.get('middle_initial').setValue('')
		this.familyForm.get('last_name').setValue('')
		// this.familyForm.get('effective_date').setValue('')
		// this.familyForm.get('noOfMonths').setValue(response.result.data[0].noOfMonths)
		// this.familyForm.get('termination_date').setValue(response.result.data[0].termination_date)
		this.familyForm.get('cell_phone').setValue('')
		this.familyForm.get('email').setValue('')
		this.familyForm.get('gender').setValue('')
		this.familyForm.get('dob').setValue('')
		this.familyForm.get('address1').setValue('')
		this.familyForm.get('postal_code').setValue('')
		this.familyForm.get('city').setValue('')
		this.familyForm.get('state').setValue('')				
	}
	getFamilyMember(id) {
		this.formMemberSubmitted = false;
		this.form1Submitted=false
		this.addFamily = true;
		this.added = false;
			this.m_pService.getAllFamilyMembers({id:id}).subscribe(response => {
				// this.familyMembers = response.result.data[0]				
					this.familyForm.get('id').setValue(response.result.data[0].id)
					this.familyForm.get('first_name').setValue(response.result.data[0].first_name)
					this.familyForm.get('middle_initial').setValue(response.result.data[0].middle_initial)
					this.familyForm.get('last_name').setValue(response.result.data[0].last_name)
					// this.familyForm.get('effective_date').setValue(response.result.data[0].effective_date)
					// this.familyForm.get('noOfMonths').setValue(response.result.data[0].noOfMonths)
					// this.familyForm.get('termination_date').setValue(response.result.data[0].termination_date)
					this.familyForm.get('cell_phone').setValue(response.result.data[0].cell_phone)
					this.familyForm.get('email').setValue(response.result.data[0].email)
					this.familyForm.get('gender').setValue(response.result.data[0].gender)
					this.familyForm.get('dob').setValue(response.result.data[0].dob)
					this.familyForm.get('address1').setValue(response.result.data[0].address)
					this.familyForm.get('postal_code').setValue(response.result.data[0].zip)
					this.familyForm.get('city').setValue(response.result.data[0].city)
					this.familyForm.get('state').setValue(response.result.data[0].state)
				// console.log('fm',response)
			})		
	}

  goToPage(event, userId = 0){

    var newForm = document.createElement('form');
    newForm.setAttribute('id', 'newForm');
    newForm.setAttribute('method', 'post');
    newForm.setAttribute('action', App.froent_end_url + event);

    var hidden_user = document.createElement("input");
    hidden_user.type = "hidden";
    hidden_user.id = "userId";
    hidden_user.name = "userId";
    hidden_user.value = App.user_details.id ? App.user_details.id : userId;
    var hidden_flag = document.createElement("input");
    hidden_flag.type = "hidden";
    hidden_flag.id = "nav_flag";
    hidden_flag.name = "nav_flag";
    hidden_flag.value = "true";

    newForm.appendChild(hidden_user);
    newForm.appendChild(hidden_flag);

    document.body.appendChild(newForm);

    newForm.submit();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

	get formArray(): AbstractControl | null { return this.userForm.get('formArray'); }

	dobMin() {
		return new Date(new Date().getFullYear()-18,new Date().getMonth(),new Date().getDate());
	}
	dobFamilyMin() {
		return new Date(new Date().getFullYear()-1,new Date().getMonth(),new Date().getDate());
	}
	getStartDate() {
		// let today = new Date(this.datePipe.transform(this.effectiveMinDate, 'yyyy-MM-dd'));
		// let effectiveDate = new Date( today.getFullYear(), today.getMonth(), today.getDate());
		// console.log(effectiveDate);
		// setTimeout(() => {
			// let finalDate = this.userForm.get('formArray')['controls'][0].controls.effective_date.value;
		// let timezone = new Date().getTimezoneOffset();
			this.userForm.get('formArray')['controls'][0].controls.effective_date.value = this.terminationMinDate
			// this.familyForm.get('effective_date').setValue(this.datePipe.transform(this.datePipe.transform(this.effectiveMinDate, 'yyyy-MM-dd'))

			this.familyForm.get('effective_date').setValue(moment(this.effectiveMinDate).format('yyyy-MM-DD'))
			return moment(this.effectiveMinDate).format('yyyy-MM-DD');
		// })

	}

	addEvent(type: string, event) {
		console.log(moment(event.value).format('yyyy-MM-DD'))
		// this.userForm.get('formArray')['controls'][0].controls.effective_date.value = this.datePipe.transform(this.userForm.get('formArray')['controls'][0].controls.effective_date.value, 'yyyy-MM-dd');
		let finalDate = moment(event.value).format('yyyy-MM-DD');
		this.terminationMinDate = finalDate;
		this.userForm.get('formArray')['controls'][0].get('effective_date').setValue(finalDate);

		// this.userForm.get('formArray')['controls'][0].controls.effective_date.value = this.datePipe.transform(event.value, 'yyyy-MM-dd');
		// // this.getEndDate(event.value)
		// // alert(this.effectiveMinDate);
		// let count = this.userForm.get('formArray')['controls'][0].controls.noOfMonths.value;
		// // let effectiveMinDate = this.userForm.get('formArray')['controls'][0].controls.effective_date.value;
		// if(count == ''){
		// 	return false;
		// }
		// let today = new Date(this.datePipe.transform(this.terminationMinDate, 'yyyy-MM-dd'));
		// let currMonth = today.getMonth();
		// // let timezone = new Date().getTimezoneOffset();

		// let endDate = new Date( today.getFullYear(), currMonth + parseInt(count), 0);
		// // console.log(endDate)
		// this.userForm.get('formArray')['controls'][0].controls.termination_date.value = this.datePipe.transform(endDate, 'yyyy-MM-dd');
		// this.familyForm.get('termination_date').setValue(this.datePipe.transform(this.effectiveMinDate, 'yyyy-MM-dd'));
	}

	getEndDate(){
		let count = this.userForm.get('formArray')['controls'][0].controls.noOfMonths.value;

		if(count == ''){
			return false;
		}
		// let today = new Date(this.datePipe.transform(this.terminationMinDate, 'yyyy-MM-dd'));
		// let currMonth = (new Date().getTimezoneOffset() > 0) ? today.getMonth() : today.getMonth();
		// let timezone = new Date().getTimezoneOffset();

		let endDate = moment(this.terminationMinDate).add((parseInt(count)-1), 'M').clone().endOf('month').format('YYYY-MM-DD')//new Date( today.getFullYear(), currMonth + parseInt(count), 0);
		// console.log(endDate)
		this.userForm.get('formArray')['controls'][0].controls.termination_date.value = endDate;
		this.familyForm.get('termination_date').setValue(endDate);
		// 	this.familyForm.get('effective_date').setValue(this.datePipe.transform(this.effectiveMinDate, 'yyyy-MM-dd'))
		return endDate;
	}

	isChecked(event){
		this.showOrganization = (event.checked) ? true : false;
		this.userForm.get('formArray')['controls'][1].controls.organization.value = ""
		if(this.showOrganization) this.getOrganizations(); 
		this.clear_coupon()
	}

	resetSelect(event) {
		this.clear_coupon()
	}

	getOrganizations(){
		this.m_pService.getOrganisationsApi().subscribe(response => {
			this.organizations_list = response.result.data;
		})
	}

	goTo(event){
		var newForm = document.createElement('form');
		newForm.setAttribute('id', 'newForm');
		newForm.setAttribute('method', 'post');
		newForm.setAttribute('action', App.froent_end_url + event);

		var hidden_user = document.createElement("input");
		hidden_user.type = "hidden";
		hidden_user.id = "userId";
		hidden_user.name = "userId";
		hidden_user.value = App.user_details.id;

		var hidden_flag = document.createElement("input");
		hidden_flag.type = "hidden";
		hidden_flag.id = "nav_flag";
		hidden_flag.name = "nav_flag";
		hidden_flag.value = "true";

		newForm.appendChild(hidden_user);
		newForm.appendChild(hidden_flag);

		document.body.appendChild(newForm);

		newForm.submit();
	}

	// ngAfterViewInit(){
	//     <HTMLInputElement>document.getElementById('credit-card-number').value = '123344565';
	// }

	submitForm(){
		console.log(this.userForm.get('formArray')['controls'][0])
		let secondary_data = {
			full_name: this.userForm.value.formArray[1].full_name,
			address_line_1: this.userForm.value.formArray[1].address_line_1,
			city2: this.userForm.value.formArray[1].city2,
			state2: this.userForm.value.formArray[1].state2,
			postal_code2: this.userForm.value.formArray[1].postal_code2	
		};
		this.userForm.value.formArray[1].billing_details = secondary_data;
		this.form2Submitted = true
		this.submitted = true;
		if(this.userForm.get('formArray')['controls'][1].controls.organization.value == "" && this.showOrganization) {
			return;
		}
		if(this.userForm.invalid){
		 return;
		 }else{
	    this.stripeService.createToken(this.card.element, {
      name: this.userForm.value.formArray[1].full_name,
      address_line1: this.userForm.value.formArray[1].address_line_1,
      address_line2: '',
      address_city: this.userForm.value.formArray[1].city2,
      address_state: this.userForm.value.formArray[1].state2,
      address_zip: this.userForm.value.formArray[1].postal_code2,
      address_country: ''}).subscribe((result) => {
	        if (result.token) {
			 	this.isPay = true;
				let userData = Object.assign(this.userForm.value.formArray[0],
				 this.userForm.value.formArray[1],
				 {token: result.token.id},
				 {card_details: result},
				 this.userDetails,
				 this.plan_details,
				 {final_total : this.total },{timezone: new Date().getTimezoneOffset()});
 				userData.first_name = this.userForm.get('formArray')['controls'][0].controls.first_name.value
 				userData.last_name = this.userForm.get('formArray')['controls'][0].controls.last_name.value
				this.saveDetails({data: userData});
				this.matStepper.next();
	        } else if (result.error) {
	          // Error creating the token
	          this.stripeValidation =result.error.message;
	        }
	      });
		}
	}

  createToken(): void {
  	// const email: string = this.userDetails.user_email;

  }
  
	saveDetails(memberdata){
		this.isLoading = true;
		this.m_pService.saveDetailsApi(memberdata).subscribe(response => {
			this.isLoading = false;
			if (response.result.success) {
				this.submitStatusMsgSuccess = true;
				this.successful_username = this.userForm.value.formArray[1].full_name;

			} else {
				this.submitStatusMsgFailed = true;
			}
		})
	}

	selectionChange(event: StepperSelectionEvent) {
		let stepIndex = event.selectedIndex;
		if (stepIndex == 0) {
			this.currentStep = 'Payment';
		}
		else if (stepIndex == 1) {
			this.currentStep = 'Payment';
		}
		else{
			this.currentStep = 'Confirmation';
		}
	}

	addMember() {
		console.log(this.familyForm)
		this.formMemberSubmitted = true;
		if(this.familyForm.valid){
			let userData = Object.assign(this.familyForm.value)
		console.log(userData)
		this.m_pService.addMemberApi(userData).subscribe(response => {
			this.isLoading = false;
			if (response.result.success) {
				// this.addFamily = false;
				this.added = true;
				this.familyMembers = []
				this.m_pService.getAllFamilyMembers('').subscribe(response => {
					this.familyMembers = response.result.data
					console.log('fm',this.familyMembers)
				})
			}
		})
		}

	}

formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}
	callPaymentMethod(){
		console.log(this.userForm.get('formArray')['controls'][0])
		this.form1Submitted = true;
		if(this.plan_details){
			if(this.plan_details.month == "1" && this.userForm.get('formArray')['controls'][0].controls.noOfMonths.value > 1){
				this.userForm.get('formArray')['controls'][1].controls.recurring_payment.value = 'checked';
				this.showRecurring = true;
				this.toogleRecurring = true;
			}else{
				this.showRecurring = false;
				this.toogleRecurring = false;
			}
			this.total = parseFloat(this.plan_details.total_plans_amount);
		}
		
		if(this.userForm.get('formArray')['controls'][0].valid){

			this.m_pService.getUserPreviousPlanAmount({start_date:this.effectiveMinDate, end_date: this.userForm.get('formArray')['controls'][0].controls.termination_date.value, plan_id: App.plan_data.plan_id}).subscribe(response => {
				if(response.result.data.old_plan_amount){
					this.prevPlanAmount = response.result.data.old_plan_amount;
					this.total = this.total - parseFloat(this.prevPlanAmount)
					// this.toogleRecurring = this.userForm.get('formArray')['controls'][0].controls.noOfMonths.value  == 1? true:false;
					// console.log(this.prevPlanAmount)
				}
			});
			// this.stripeService.changeKey('pk_test_51HYo8JIU6EOWyLAQKryyrgURPOR8bSywVMs6BvBkVmhFOCijgB5bCKJQYOvhjSR5Q29tJCQC8XrM1jMwemx2ofrg00IdhDUVqJ');
		}else{
			console.log('Form Not Validated, please recheck')
		}
	}

	changedetectorfunc(value) {
		if(!this.userForm.get('formArray')['controls'][0].controls.cell_phone.value.includes('-')){
			this.phoneMaxLength = 10;
			this.phoneMinLength = 10;
		}else{
			this.phoneMaxLength = 12;
			this.phoneMinLength = 12;
		}
	}

	/* Needed when we have multiple countries list */
	/* countrySelected(event){
		if(event.value != '')
		this.getStates({country_name: event.value});
	} */

	getStates(countryCode){
		this.m_pService.getStatesApi(countryCode).subscribe(response => {
			this.States = response.result.data;
		});
	}

	applyCoupon(event){
		let data = {
					type: 'Telemedicine', 
					amount: parseFloat(this.plan_details.total_plans_amount),
					coupon_number: this.userForm.get('formArray')['controls'][1].controls.coupon_code.value,
					organization: this.userForm.get('formArray')['controls'][1].controls.organization.value
				};

		this.m_pService.getCouponsApi(data).subscribe(response => {
			if(response.result.success){
				this.emptyCoupon = (response.result.data != null) ? false : true;

				if(!this.emptyCoupon){
					this.isCouponApplied = true;
					this.couponDiscount = response.result.data.discount_amount;
					if(this.plan_details)
					this.total = parseFloat(this.plan_details.total_plans_amount) - parseFloat(this.couponDiscount);
				if(this.prevPlanAmount>0){
					this.total = this.total-this.prevPlanAmount;
				}
				}
			}
		});
	}

	clear_coupon(){
		this.emptyCoupon = false;
		let obj ={id : this.coupounId}
		this.m_pService.deleteCoupon(obj).subscribe(response => {})
		this.userForm.get('formArray')['controls'][1].controls.coupon_code.patchValue('');
		if(this.isCouponApplied) this.isCouponApplied = false;
		this.total = this.total + parseFloat(this.couponDiscount);
 	}

	setPrimary(event){
			let control_0 = this.userForm.get('formArray')['controls'][0].controls;
			let control_1 = this.userForm.get('formArray')['controls'][1].controls;
		if(event.checked){
			let full_name = control_0.first_name.value + ' ' +  control_0.middle_initial.value + ' ' +  control_0.last_name.value;
			let address_line_1 = control_0.address1.value;
			let state2 = control_0.state.value;
			let postal_code2 = control_0.postal_code.value;
			let city2 = control_0.city.value;

			control_1.full_name.patchValue(full_name);
			control_1.address_line_1.patchValue(address_line_1);
			control_1.state2.patchValue(state2);
			control_1.postal_code2.patchValue(postal_code2);
			control_1.city2.patchValue(city2);

		}else{
			control_1.full_name.patchValue('');
			control_1.address_line_1.patchValue('');
			control_1.state2.patchValue('');
			control_1.postal_code2.patchValue('');
			control_1.city2.patchValue('');
		}
	}



}

